import SwipeableViews from 'react-swipeable-views'
import FormatFields from './components/FormatFields'
import './styles.css'

export default function FormContents({
  classes,
  handleSubmit,
  activeStep,
  handleChange,
  formSelected,
  handleInput,
  fields
}) {
  return(
    <form onSubmit={handleSubmit}>
      <SwipeableViews index={activeStep} onChangeIndex={handleChange} className='FormContent__root'>
        {!formSelected.fields
          ? ''
          : formSelected.fields.map((field, index) => {
            return(
              <FormatFields 
                classes={classes}
                field={field}
                handleInput={handleInput}
                formSelected={formSelected}
                fields={fields}
              />
            )
          })
        }
      </SwipeableViews>
    </form>
  )
}